import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import AlertService from '@app/model/alert/service/AlertService';
import { AlertExecutionQueryKeys } from '@app/model/alert/service/AlertQueryKeys';
import Message from '@app/component/message/Message';
import TablePlaceholder from '@app/component/placeholder/TablePlaceholder';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import AlertExecutionFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/AlertExecutionFragment';

const AlertExecutionPage = React.memo(() => {
	const { alertExecutionId } = useParams();

	return !!alertExecutionId ? <Inside alertExecutionId={parseInt(alertExecutionId)} /> : <Message state='error'>Alert execution could not be found!</Message>;
});

const Inside: React.FunctionComponent<{ alertExecutionId: number }> = ({ alertExecutionId }) => {

	const {companyHotel} = useSelectedCompanyHotel();

	const { data: alertExecution, isSuccess, isError } = useQuery({
		queryFn: () => AlertService.findAlertExecutionById(companyHotel.id, alertExecutionId),
		queryKey: AlertExecutionQueryKeys.detail(alertExecutionId),
	});

	if (isSuccess)
		return <AlertExecutionFragment alertExecution={alertExecution} />;
	else if (isError)
		return <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8"><Message state="warning">Alert execution could not be found</Message></div>;
	else return <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8"><TablePlaceholder /></div>;
};

export default AlertExecutionPage;